import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import TextField from 'material-ui/TextField/TextField';

const TextInput = (props) => {
    const {
        className,
        elStyle,
        input,
        label,
        meta: {
            touched,
            error,
        },
        options,
        resource,
        source,
        type,
        onBlur,
        onFocus,
        onChange,
    } = props;

    const handleBlur = (eventOrValue) => {
        onBlur(eventOrValue);
        input.onBlur(eventOrValue);
    };

    const handleFocus = (event) => {
        onFocus(event);
        input.onFocus(event);
    };

    const handleChange = (eventOrValue) => {
        onChange(eventOrValue);
        input.onChange(eventOrValue);
    };

    return (
        <TextField
            { ...input }
            className={ className }
            onBlur={ handleBlur }
            onFocus={ handleFocus }
            onChange={ handleChange }
            type={ type }
            floatingLabelText={ label ? <FieldTitle
                label={ label }
                source={ source }
                resource={ resource }
            /> : '' }
            errorText={ touched && error }
            style={ elStyle }
            { ...options }
        />
    );
};

TextInput.defaultProps = {
    onBlur: () => {},
    onChange: () => {},
    onFocus: () => {},
    options: {},
    type: 'text',
};

TextInput.propTypes = {
    className: PropTypes.string,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    type: PropTypes.string,
    validate: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.func),
    ]),
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/input/TextInput/TextInput.js